import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { del } from "../../lib/request"

/** Pipelines DELETE /api/v1/{channel}/post/:postId */
const CHANNEL_TO_PATH = {
  facebook: "facebook",
  twitter: "twitter",
  linkedin: "linkedin",
}

export const deleteLiveSocialPost = createAsyncThunk(
  "liveSocialPostDelete/delete",
  async ({ channel, postId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth?.token
      if (!token) {
        throw new Error("Authentication required. Please login first.")
      }
      if (!postId) {
        throw new Error("Post ID is required")
      }
      const pathPrefix = CHANNEL_TO_PATH[channel]
      if (!pathPrefix) {
        throw new Error("Unsupported channel for live post delete")
      }
      await del(`${pathPrefix}/posts/${postId}`)
      return { postId, channel }
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to delete live post")
    }
  },
)

const initialState = {
  status: "idle",
  error: null,
  lastDeletedPostId: null,
}

const liveSocialPostDeleteSlice = createSlice({
  name: "liveSocialPostDelete",
  initialState,
  reducers: {
    clearLiveSocialPostDeleteError: (state) => {
      state.error = null
    },
    resetLiveSocialPostDeleteStatus: (state) => {
      state.status = "idle"
      state.error = null
      state.lastDeletedPostId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteLiveSocialPost.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(deleteLiveSocialPost.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.lastDeletedPostId = action.payload.postId
      })
      .addCase(deleteLiveSocialPost.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload || "Failed to delete live post"
      })
  },
})

export const { clearLiveSocialPostDeleteError, resetLiveSocialPostDeleteStatus } =
  liveSocialPostDeleteSlice.actions

export default liveSocialPostDeleteSlice.reducer
